import Axios from 'axios';
import { call, takeLatest, put, cancelled, debounce } from 'redux-saga/effects';
import get from 'lodash/get';
import moment from 'moment-timezone';
import instance from '@api/axiosInstance';
import { APP_VIEWER_SESSIONS_METRIC_FIELDS, APP_VIEWER_SESSIONS_QUERY_CONFIG } from './constants';
import * as dataTypes from './types';
import { UPDATE_QUERY } from './types';
import { getUsersData } from '@src/api/ecoUsers';
import { triggerDeletedFieldsError } from '@utils/errors/triggerPageError';
function* fetchAppViewerSessionData(action: {
  query: {
    filter?: any[];
    metrics?: string[];
    metricFilter?: any[];
    interval: {
      from: string;
      granularity: string;
      to: string;
    };
    dimensions?: string[];
    sortBy?: any[];
    dataScope?: string;
    presetKey?: string;
    viewId?: string;
    eventId?: string;
  };
}) {
  const {
    query: {
      filter = [],
      metrics = APP_VIEWER_SESSIONS_METRIC_FIELDS,
      metricFilter,
      interval,
      dimensions = [],
      sortBy = [],
      dataScope,
      presetKey,
      viewId,
      eventId,
    },
  } = action;

  const customPayload: {
    type?: 'multi-group-by' | 'group-by';
    dataset: string;
    metrics?: string[];
    metricFilter?: any[];
    interval?: string;
    filter: any[];
    limit: number;
    granularity: 'ALL';
    groupBy?: string[];
    orderBy: 'desc' | 'asc';
    options: {
      withTotals: boolean;
      dataScope?: string;
      presetKey?: string;
      viewId?: string;
      eventId?: string;
    };
    sortBy: any[];
  } = {
    type: 'group-by',
    dataset: 'AppExperience',
    metrics,
    interval: `${moment(interval.from).format()}/${moment(interval.to).format()}`,
    granularity: 'ALL',
    filter: filter.concat(APP_VIEWER_SESSIONS_QUERY_CONFIG.filter),
    limit: 1500,
    groupBy: dimensions.length > 0 ? dimensions : ['app_user_id'],
    orderBy: 'desc',
    options: {
      withTotals: false,
      ...(dataScope && { dataScope }),
      ...(presetKey && { presetKey }),
      ...(eventId && { eventId }),
      viewId,
    },
    sortBy,
  };
  if (metricFilter && metricFilter.length > 0) {
    customPayload.metricFilter = metricFilter;
    customPayload.type = 'multi-group-by';
  }
  const payload = { queries: [customPayload] };
  yield put({
    type: UPDATE_QUERY,
    query: payload,
  });
  yield put({
    type: dataTypes.FETCHING,
    query: payload,
  });
  const source = Axios.CancelToken.source();
  try {
    const resp = yield call(
      getUsersData,
      payload,
      {
        cancelToken: source.token,
      },
      instance,
    );
    const data = get(
      resp.data,
      `${customPayload.type === 'multi-group-by' ? 'metricFilterData.' : ''}0.data.0.results`,
      [],
    );
    const annotations = get(
      resp.data,
      `${customPayload.type === 'multi-group-by' ? 'metricFilterData.' : ''}0.annotations`,
      [],
    );
    triggerDeletedFieldsError(annotations);
    yield put({
      type: dataTypes.FETCHING_SUCCESS,
      response: data,
    });
  } catch (err) {
    yield put({
      type: dataTypes.FETCHING_FAIL,
      errorMsg: get(err, 'response.data.message'),
    });
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

function* watchFetchData() {
  yield debounce(300, [dataTypes.FETCH_DATA], fetchAppViewerSessionData);
}

export default [watchFetchData];
